module.exports = __webpack_public_path__ + "static/rounded-img3-2415127fe2fa7d38e4d006dccd110860.png";